import { useEffect } from 'react';
import { useParams } from 'react-router';
import { useSignageConfig } from '@/config/ConfigProvider';
import { ModuleLoader } from '@/widgets/ModuleLoader';

/**
 * The only route component (was `views/Home.vue`).
 *
 * Legacy `Home.vue` did two things: it pulled `components`/`layout`/`slider` off the global
 * config and passed them to `ModuleLoader`, and it wrote the body theme to `document`. The
 * first is now `useSignageConfig()` inside `ModuleLoader` itself; the second belongs to
 * `useDocumentTheme()` in `App` (SYM-502), which also owns the `.signage-container` element
 * this renders into. What is left is the route's own diagnostic.
 */
export function SignageRoute() {
  const config = useSignageConfig();
  // `:floor` is not used to render anything — the floor the widgets use comes from
  // `config.floorCode`. It still has to match, because deployed displays are configured
  // with URLs like `/szeged_2/2`.
  const { floor } = useParams<{ signage: string; floor?: string }>();

  useEffect(() => {
    console.info(
      '[signage] url floor=%s, config.floorCode=%s',
      floor ?? '(none)',
      config.floorCode,
    );
    if (floor !== undefined && floor !== config.floorCode) {
      console.warn(
        '[signage] url floor "%s" does not match config.floorCode "%s" — the config wins. ' +
          'If this display shows the wrong floor, the site is misconfigured.',
        floor,
        config.floorCode,
      );
    }
  }, [floor, config.floorCode]);

  return <ModuleLoader />;
}
